import classnames from 'classnames';
import React from 'react';

const ProgramFilterSkeleton: React.FC<{
    className?: string;
}> = ({ className }) => {
    return (
        <div className={classnames(className, 'relative justify-end flex flex-row space-x-12')}>
            <div className="w-100 h-48 bg-[var(--surface-color)] rounded-4 animate-pulse-skeleton" />
            <div className="w-100 h-48 bg-[var(--surface-color)] rounded-4 animate-pulse-skeleton" />
        </div>
    );
};

export default ProgramFilterSkeleton;
